import React, { ChangeEvent, ReactNode } from "react";
import { observer } from "mobx-react-lite";
import { Radio } from "@mui/material";

import "./RadioButton.scss";
import useThemeService from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";

interface RadioButtonProps {
  children?: ReactNode;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  checked: boolean;
  labelKey?: string;
  name?: string;
}

export default observer(function RadioButton(props: RadioButtonProps) {
  const { value, checked, onChange, labelKey, name, children } = props;
  const { themeClass } = useThemeService();

  const inputLabel = (
    <label className={themeClass(["label-edit"])}>
      {labelKey ? translationService.translate(labelKey) : null}
    </label>
  );

  return (
    <div className="radio-button">
      <Radio
        className="radio"
        name={name ?? "radio"}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {labelKey && inputLabel}
      {children}
    </div>
  );
});
